import { ContainerComponent, wrap } from 'AppReact';
import {
  CustomBackgroundWrapper, FitRelativeWrapper, AbsoluteRightTopWrapper,
  Mr3, FullWidthFlexBoxWrapper, WhiteSpaceNoWrap, Mt3, AbsolutePositionWrapper,
  GenericWrapper, MaxWidthHeight, FullWIdthColumnScrollWrapper
} from 'wrappers';
import { WhiteTextSm, TagText, PrimaryTextSm } from 'atoms';
import { RemovableTagText } from 'molecules';
import Controller from './controller';
import internalState from './internalState';
import { getIsMobile } from 'utils';

const isMobile = getIsMobile();

export const definition = {
  name: 'MultipleTagsPopup',
  controller: Controller,
  initialProps: ({ tags, textHeader, canRemove }) => ({ tags, textHeader, canRemove }),
  props: internalState,
  elements: [
    {
      wrapper: isMobile ? GenericWrapper : FitRelativeWrapper,
      name: '__transparent__',
      elements: [
        {
          wrapper: CustomBackgroundWrapper,
          bindings: ({ containerRef, isOpen }) => ({ isOpen, containerRef }),
          isButton: true,
          name: 'Header',
          displayState: ({ textHeader }) => ({
            background: textHeader ? '' : window?.settings?.primary_color,
            padding: '0px 12px',
            height: '25px',
            alignItems: 'center',
            borderRadius: '60px',
            cursor: 'pointer'
          }),
          elements: [
            {
              component: WhiteTextSm,
              renderIf: ({ textHeader }) => !textHeader,
              name: 'Text',
              displayValue: ({ tags }) => `+${tags.length}`,
            },
            {
              component: PrimaryTextSm,
              renderIf: ({ textHeader }) => textHeader,
              name: 'Text',
              displayValue: ({ tags }) => `+${tags.length} tags`,
            }
          ]
        },
        {
          wrapper: isMobile ? AbsolutePositionWrapper : AbsoluteRightTopWrapper,
          name: 'BodyWrapper',
          displayState: ({ }) => ({ top: isMobile ? '' : '32px', bottom: isMobile ? '32px' : '', left: isMobile ? '0px' : '' }),
          ref: ({ containerRef }) => containerRef ?? null,
          renderIf: ({ isOpen }) => isOpen,
          elements: [
            {
              wrapper: CustomBackgroundWrapper,
              name: 'Wrapper',
              displayState: ({ }) => ({ border: '1px solid #E3E3E3', padding: '2px 16px 14px 16px', background: '#FFFFFF', borderRadius: '20px', width: '350px' }),
              elements: [
                {
                  wrapper: MaxWidthHeight,
                  name: 'BodyWrapper',
                  displayState: ({ }) => ({ width: '350px', height: '235px', display: 'flex' }),
                  elements: [
                    {
                      wrapper: wrap(FullWidthFlexBoxWrapper, FullWIdthColumnScrollWrapper),
                      name: 'ListWrapper',
                      elements: [
                        {
                          component: wrap(wrap(wrap(TagText, Mr3), WhiteSpaceNoWrap), Mt3),
                          name: 'TagText',
                          renderIf: ({ canRemove }) => !canRemove,
                          isListOf: 'tags',
                          displayState: ({ tag }) => ({ color: tag?.color }),
                          displayValue: ({ tag }) => tag?.name ?? ''
                        },
                        {
                          component: wrap(wrap(wrap(RemovableTagText, Mr3), WhiteSpaceNoWrap), Mt3),
                          name: 'RemoveTags',
                          renderIf: ({ canRemove }) => canRemove,
                          isListOf: 'tags',
                          displayState: ({ tag }) => ({ color: tag?.color }),
                          bindings: ({ tag }) => ({ tag, color: tag?.color, name: tag?.name ?? '' }),
                        },
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};

export default ContainerComponent(definition);
